import React from 'react';
import Link from '@tphglobal/components/link';
import { brand } from '@tphglobal/common/theme/style.palette';
import messages from '../../messages';

interface TermsLinkItem {
  href: string;
  label: string;
}

interface TermsLinksProps {
  links: TermsLinkItem[];
}

const TermsLinks: React.FC<TermsLinksProps> = ({ links }) => {
  // Helper function to get the appropriate separator
  const getSeparator = (index: number): React.ReactNode => {
    if (index < links.length - 2) {
      return ', ';
    } else if (index === links.length - 2) {
      return <span> {messages?.general?.and} </span>;
    } else {
      return '.';
    }
  };

  return (
    <>
      {links.map((link, index) => (
        <React.Fragment key={link.href}>
          {index === 0 && ' '}
          <Link
            href={link.href}
            color={brand?.secondaryMain}
            label={link.label}
            variant='Fixed14Medium'
            target='_blank'
          />
          {getSeparator(index)}
        </React.Fragment>
      ))}
    </>
  );
};

export default TermsLinks;
